import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { colors } from '../theme';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: colors.royalBlue,
        color: 'white',
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl" sx={{ textAlign: 'center' }}>
        <Typography variant="body2" sx={{ opacity: 0.9, mb: 0.5 }}>
          獅聲心語 — 國際獅子會中國港澳303區 Lions Clubs International District 303
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7, fontSize: '0.8rem' }}>
          © {currentYear} Lions Clubs International District 303 (Hong Kong & Macao, China). All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
